module.exports = __webpack_public_path__ + "static/img/07bg.a0c2ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/dark/share/01home/07bg.png
// module id = CD7K
// module chunks = 0